<template>
  <div class="history">
    <span class="tips">每日辟谣</span>
    <van-list
      v-model="pointLoading"
      :finished="pointFinished"
      :error.sync="pointError"
      error-text="请求失败，点击重新加载"
      :finished-text="finishText"
      @load="Historylist"
    >
      <div class="popup_wrap" v-for="(item, index) in answerlist" :key="index">
        <div class="question">{{ item.title }}</div>
        <div class="doctor">
          <div class="doctor_content">
            <img :src="item.headImageUrl" alt="" class="doctor_img" />
            <div class="doctor_name">
              <div class="name">{{ item.realName }}</div>
              <div class="position">{{ item.hospital + item.position }}</div>
            </div>
          </div>
        </div>
        <div class="is_answer">
          <div v-if="item.answerResults" class="answer">
            <img
              :src="
                require('../../../../assets/images/powderedMilk/answerTrue.png')
              "
              class="imgTrue"
              alt=""
            />
            <span class="true">你答对啦！超棒呦！</span>
          </div>
          <div v-else class="answer">
            <img
              :src="
                require('../../../../assets/images/powderedMilk/answerFalse.png')
              "
              class="imgfalse"
              alt=""
            />
            <span class="false">答错啦！</span>
          </div>
          <div class="doctor_answer">答案：{{ item.answer ? "是" : "否" }}</div>
        </div>
        <div class="analysis">
          <div>
            <img
              :src="
                require('../../../../assets/images/powderedMilk/analysis.png')
              "
              alt=""
              class="analysis_tag"
            />
          </div>
          <span class="analysis_content">{{ item.analysis }}</span>
          <div class="analysis_Date">{{ item.createTime }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import Index from "./js/index.js";
export default Index;
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>